import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PinsLogicService } from './logic/pins/pins-logic.service';
import { PinsService } from './logic/pins.service';
import { PinsDaoService } from './dao/pins-dao.service';
import { PinsDbDaoService } from './dao/pins-dao/pins-db-dao.service';
import { PinDbTableDefinition } from './dao/pins-dao/pin-db-table-definition';
import { LocalPinDbTableDefinition } from './dao/pins-dao/local-pin-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: PinsService, useClass: PinsLogicService },
    { provide: PinsDaoService, useClass: PinsDbDaoService },
    { provide: PinDbTableDefinition },
    { provide: LocalPinDbTableDefinition },
  ]
})
export class PinsModule {}
